import CityPageTemplate from "../city-template/CityPageTemplate";
import { exeterConfig } from "./data";

export default function ExeterPage() {
  return <CityPageTemplate config={exeterConfig} />;
}